import { render, staticRenderFns } from "./phone_alarm.vue?vue&type=template&id=2f249d50&scoped=true&"
import script from "./phone_alarm.vue?vue&type=script&lang=js&"
export * from "./phone_alarm.vue?vue&type=script&lang=js&"
import style0 from "./phone_alarm.vue?vue&type=style&index=0&id=2f249d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f249d50",
  null
  
)

export default component.exports